class Bundle {
    constructor(
        public id: number = 0,
        public nom: string = "",
        public valor: string = "",
        public env: string = "",
    ) {}
}

export {Bundle};